import {Grid} from '@primer/react-brand/esm'

import {ContentfulCtaBanner} from '@github-ui/swp-core/components/contentful/ContentfulCtaBanner'
import type {PrimerComponentCtaBanner} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentCtaBanner'

import type {GenericSectionWithIds} from '../../../../brand/lib/types/contentful'

type Props = {
  contentfulContent: GenericSectionWithIds
}

export function CtaBannerSection(props: Props) {
  const {contentfulContent} = props
  const {content} = contentfulContent.fields

  const ctaBannerComponent = content?.find(item => item.sys.contentType.sys.id === 'primerComponentCtaBanner') as
    | PrimerComponentCtaBanner
    | undefined

  if (!ctaBannerComponent) {
    return null
  }

  return (
    /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
    <section id="resources" className="lp-Resources-wrapper">
      {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
      <Grid className="lp-Section-container--centerUntilMedium lp-Grid--noRowGap tmp-pb-8 tmp-pb-md-12 tmp-pt-8 tmp-pt-md-12 lp-Resources-container border-top-0">
        <Grid.Column span={12}>
          <ContentfulCtaBanner component={ctaBannerComponent} />
        </Grid.Column>
      </Grid>
    </section>
  )
}
